import { useState, useContext, useEffect } from 'react'
import { ModalContext } from '../ModalContext'
import { APIContext } from 'context/APIContext'
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'

import BrandColorButton from 'components/Buttons/BrandColorButton'

export default function DeleteProgramModal() {

    const { modalData, HideModal } = useContext(ModalContext)
    const { GetProgramTechnicalStats } = useContext(APIContext)

    const programId = modalData?.programId ?? null

    const [programTechnicalStats, setProgramTechnicalStats] = useState(null)
    const [isLoading, setIsLoading] = useState(false)

    const LoadProgramTechnicalStats = async () => {
        setProgramTechnicalStats(null)
        const result = await GetProgramTechnicalStats(programId)
        setProgramTechnicalStats(result)
    }

    const OnActionButtonClicked = async () => {

        setIsLoading(true)
        
        await modalData.buttonAction()

        setIsLoading(false)
        
        HideModal()
    }

    useEffect(() => { LoadProgramTechnicalStats() }, [programId])

    if (programId === null) return null

    return (
        <>
            <div className="mx-auto flex h-14 w-14 flex-shrink-0 items-center justify-center rounded-full bg-orange-400">
                <ExclamationTriangleIcon className="h-8 w-8 text-white" aria-hidden="true" />
            </div>

            <div className="text-center text-lg font-semibold leading-6 text-gray-900">{modalData.titleText}</div>

            <div className="space-y-2">
                {modalData.bodyText.map((text, index) => (
                    <p key={index} className="text-sm text-gray-600">
                        {text}
                    </p>
                ))}
            </div>

            {programTechnicalStats === null && 
                <div className='h-60 bg-gray-200 rounded-lg animate-pulse' />
            }

            {programTechnicalStats !== null &&
                <div className='h-60 bg-gray-200 rounded-lg overflow-y-auto p-2 text-left'>
                    <p>Program levels: <strong>{programTechnicalStats?.programLevelCount}</strong></p>
                    <p>Macro volume phase types: <strong>{programTechnicalStats?.macroVolumePhaseTypeCount}</strong></p>
                    <p>Macro volume focus types: <strong>{programTechnicalStats?.macroVolumeFocusTypeCount}</strong></p>
                    <p>Micro volume stimulus types: <strong>{programTechnicalStats?.microVolumeStimulusTypeCount}</strong></p>
                    <p>Workout phase types: <strong>{programTechnicalStats?.workoutPhaseTypeCount}</strong></p>
                    <p>Workout configs: <strong>{programTechnicalStats?.workoutConfigCount}</strong></p>
                    <p>Workout phase configs: <strong>{programTechnicalStats?.workoutPhaseConfigCount}</strong></p>
                    <p>Workout slot configs: <strong>{programTechnicalStats?.workoutSlotConfigCount}</strong></p>
                    <p>Workout config weekday assignments: <strong>{programTechnicalStats?.workoutConfigWeekdayAssignmentCount}</strong></p>
                    <p>Program volume configs: <strong>{programTechnicalStats?.programVolumeConfigCount}</strong></p>
                    <p>Macro volume phases: <strong>{programTechnicalStats?.macroVolumePhaseCount}</strong></p>
                    <p>Macro volume focuses: <strong>{programTechnicalStats?.macroVolumeFocusCount}</strong></p>
                    <p>Meso volumes: <strong>{programTechnicalStats?.mesoVolumeCount}</strong></p>
                    <p>Micro volumes: <strong>{programTechnicalStats?.microVolumeCount}</strong></p>
                    <p>Nano volumes: <strong>{programTechnicalStats?.nanoVolumeCount}</strong></p>
                    <p>Exercise blocks: <strong>{programTechnicalStats?.exerciseBlockCount}</strong></p>
                    <p>Exercise collections: <strong>{programTechnicalStats?.exerciseCollectionCount}</strong></p>
                    <p>Exercise collection cycles: <strong>{programTechnicalStats?.exerciseCollectionCycleCount}</strong></p>
                    <p>Exercise collection cycle exercises: <strong>{programTechnicalStats?.exerciseCollectionCycleExerciseCount}</strong></p>
                    <p>Workouts: <strong>{programTechnicalStats?.workoutCount}</strong></p>
                    <p>Workout phases: <strong>{programTechnicalStats?.workoutPhaseCount}</strong></p>
                    <p>Workout slots: <strong>{programTechnicalStats?.workoutSlotCount}</strong></p>
                    <p>Workout sets: <strong>{programTechnicalStats?.workoutSetCount}</strong></p>
                </div>
            }

            <BrandColorButton
                text={modalData.buttonText}
                action={OnActionButtonClicked}
                isLoading={isLoading}
            />
        </>
    )
}
